import React from "react";
import EmptySeat from "../../../../../assets/img/empty-seat.png";

function Picture3({ seat }) {
    return (
        // <img
        //     ref={drag}
        //     src={url}
        //     width="150px"
        //     style={{ border: isDragging ? "5px solid pink" : "0px" }}
        // />

        <div>
            <img src={EmptySeat} alt="" width={25}/>
            <div>
              {
                seat
              }
            </div>
        </div>


    );
}

export default Picture3;
